'use strict';

require('../../style/index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/icon/style/css.js
// module id = 34
// module chunks = 18604960509584 35783957827783 103869943198658 114276838955818 222368950809299